import { render } from "./EditComponent.vue?vue&type=template&id=178087e6&scoped=true&ts=true"
import script from "./EditComponent.vue?vue&type=script&lang=ts"
export * from "./EditComponent.vue?vue&type=script&lang=ts"

import "./EditComponent.vue?vue&type=style&index=0&id=178087e6&scoped=true&lang=css"
import "./EditComponent.vue?vue&type=style&index=1&id=178087e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178087e6"]])

export default __exports__